import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const DomainVerificationConfirmModal = lazy(() => import('.'))

class DomainVerificationConfirmModalWebComponent extends ReactWebComponent {
	override render() {
		return (
			<RootProviders>
				<DomainVerificationConfirmModal />
			</RootProviders>
		)
	}
}

customElements.define(
	'domain-verification-confirm-modal',
	DomainVerificationConfirmModalWebComponent,
)
